var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"research-block"},[_c('ResearchShooting')],1),(!_vm.loading)?_c('div',{staticClass:"container-block_gallery"},[_c('ShootingsGallery'),(_vm.shootings.length > 0)?_c('LoadMore'):_vm._e()],1):_c('div',{staticClass:"loader-block"},[_c('Loader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }